import React, { Component } from 'react'
import Panel from '@common/Panel'
import { inject, observer } from 'mobx-react'
import { Carousel } from 'hljd'
import styles from './style.module.less'

@inject('store')
@observer
export default class extends Component {
  render() {
    const { taskPageData } = this.props.store
    const { peerOverview } = taskPageData || {}

    return (
      <>
        <Panel
          title="同行概览"
          style={{ width: 400, marginRight: 20 }}
          contentStyle={{
            height: 290,
            position: 'relative',
            padding: 0
          }}
        >
          <div className={styles.carouselWrapper}>
            <Carousel autoplay>
              {(peerOverview || []).slice(0, 3).map(src => {
                return <img src={src} width="400" />
              })}
            </Carousel>
          </div>
        </Panel>
      </>
    )
  }
}
